import { Address } from "@/models/address";

export class ContactInfo {
  firstName: string = "";
  surname: string = "";
  phone: string = "";
  countryCode: string = "";
  email: string = "";
  address: Address = new Address();
}